import { GeneralModel } from "./general.model";

export class Department extends GeneralModel {
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/models/department.model.ts